export const maskMobileNumber = (mobileNumber) => {
    if (!mobileNumber) return '';
    let maskedNumber = ''
    if (mobileNumber.length) {
        if (mobileNumber.length > 2 && mobileNumber.length < 10) {
            maskedNumber = mobileNumber.substring(0, 2) + '*'.repeat(mobileNumber.length - 2);
        } else if (mobileNumber.length === 10) {
            maskedNumber = mobileNumber.substring(0, 2) + '*'.repeat(mobileNumber.length - 5) + mobileNumber.substring(mobileNumber.length - 3);
        }else{
            const firstTwoDigits = mobileNumber.slice(0, 2);
            const lastThreeDigits = mobileNumber.slice(-3);
            const middleDigitsCount = mobileNumber.length - firstTwoDigits.length - lastThreeDigits.length;
            const maskedMiddle = '*'.repeat(middleDigitsCount);
            maskedNumber = `${firstTwoDigits}${maskedMiddle}${lastThreeDigits}`;
        }
    }
    return maskedNumber;
};